import { render } from "./FamiliesCardsComponent.vue?vue&type=template&id=02bd0b0e&scoped=true"
import script from "./FamiliesCardsComponent.vue?vue&type=script&lang=js"
export * from "./FamiliesCardsComponent.vue?vue&type=script&lang=js"

import "./FamiliesCardsComponent.vue?vue&type=style&index=0&id=02bd0b0e&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bd0b0e"]])

export default __exports__